import { combineReducers } from 'redux';

import { sessionReducer } from './session';
import { entitiesReducer } from './entities';
import resetPassword from './resetPassword';

import { appReducer } from './app';

import paging from './paging';

import { errorsReducer } from './errors';
import { requestReducer } from './request';
import { processesReducer } from './processes';
import routes from './routes';

import { usersReducer } from './users';
import { teamsReducer } from './teams';
import { orgsReducer } from './orgs';
import { sourcesReducer } from './sources';
import { sinksReducer } from './sinks';
import { dataSetsReducer } from './dataSets';
import { sharedDatasetsReducer } from './dataSetsShared';
import { publicDatasetsReducer } from './dataSetsPublic';

import { dataMapsReducer } from './dataMaps';
import { dataMapEditFormReducer } from './dataMapEditForm';

import { credentialsReducer } from './credentials';
import { samplesReducer } from './samples';
import { notificationsReducer, notificationsManagerReducer } from './notifications';
import dataSetSchemas from './dataSetSchemas';
import { metricsReducer } from './metrics';
import { formsReducer } from './forms';
import { fileUploadProbeReducer } from './fileUploadProbe';
import { probeReducer } from './probe';
import { transformsReducer } from './transforms';
import { schemaEditorReducer } from './schemaEditor';
import { recipeBuilderReducer } from './recipeBuilder';
import { pipelineReducer } from './pipeline';
import ragReducer from './rag';
import ProjectReducer from './project';
import { tagsReducer } from './tags';
import { auditLogReducer } from './auditLog';
import { aclReducer } from './acl';

import { paginationReducer } from './pagination';
import { vendorsReducer } from './vendors';
import { dbDataTypesReducer } from './dbDataTypes';
import { schemaSpecsReducer } from './schemaSpecs';
import { apiKeysReducer } from './apiKeys';
import { serviceKeysReducer } from './serviceKeys';
import { sdkApplicationsReducer } from './sdkApplications';

import { idpConfigReducer } from './idpConfig';
import changePassword from 'new/stores/changePassword/reducer';
import alertVisibilityReducer from 'new/stores/showAlert/reducer';
import { capsuleReducer } from 'new/stores/capsules/capsule.slice';
import { capsulesApi } from 'new/stores/capsules/capsules.api';
import { adminOrgsApi } from 'new/stores/adminOrgs/adminOrgs.api';
import { recommendationsReducer } from 'js/reducers/recommendations';
import { hashedState } from 'new/state/hashedState/reducer';
import { domainsReducer } from './domains';
import { credentialsGroupsReducer } from './credentialsGroups';
import { splitterReducer } from './splitter';
import { flowCategoriesReducer } from 'js/reducers/flowCategories';
import aiToolsReducer from './aiTools';
import aiToolsetsReducer from './aiToolsets';
import aiToolsetExportsReducer from './aiToolsetExports';
import { aiApi } from 'new/modules/ai/state/aiApi';
import { metricsApi } from 'new/stores/metrics/metrics.api';

export default combineReducers({
  [aiApi.reducerPath]: aiApi.reducer,
  [capsulesApi.reducerPath]: capsulesApi.reducer,
  [metricsApi.reducerPath]: metricsApi.reducer,
  [adminOrgsApi.reducerPath]: adminOrgsApi.reducer,
  ai: combineReducers({
    aiTools: aiToolsReducer,
    aiToolsets: aiToolsetsReducer,
    aiToolsetExports: aiToolsetExportsReducer,
  }),
  entities: entitiesReducer,
  acl: aclReducer,
  alertVisibility: alertVisibilityReducer,
  apiKeys: apiKeysReducer,
  app: appReducer,
  auditLog: auditLogReducer,
  capsules: capsuleReducer,
  changePassword,
  credentials: credentialsReducer,
  credentialsGroups: credentialsGroupsReducer,
  dataMapEditForm: dataMapEditFormReducer,
  dataMaps: dataMapsReducer,
  dataSetSchemas,
  dataSets: dataSetsReducer,
  dbDataTypes: dbDataTypesReducer,
  domains: domainsReducer,
  errors: errorsReducer,
  forms: formsReducer,
  fileUploadProbe: fileUploadProbeReducer,
  idpConfig: idpConfigReducer,
  hashedState,
  metrics: metricsReducer,
  notifications: notificationsReducer,
  notificationsManager: notificationsManagerReducer,
  orgs: orgsReducer,
  pagination: paginationReducer,
  paging,
  pipelines: pipelineReducer,
  probe: probeReducer,
  processes: processesReducer,
  projects: ProjectReducer,
  publicDatasets: publicDatasetsReducer,
  rag: ragReducer,
  recipeBuilder: recipeBuilderReducer,
  recommendations: recommendationsReducer,
  request: requestReducer,
  resetPassword,
  routes,
  samples: samplesReducer,
  schemaEditor: schemaEditorReducer,
  schemaSpecs: schemaSpecsReducer,
  session: sessionReducer,
  sharedDatasets: sharedDatasetsReducer,
  sinks: sinksReducer,
  sources: sourcesReducer,
  splitter: splitterReducer,
  serviceKeys: serviceKeysReducer,
  sdkApplications: sdkApplicationsReducer,
  tags: tagsReducer,
  teams: teamsReducer,
  transforms: transformsReducer,
  users: usersReducer,
  vendors: vendorsReducer,
  flowCategories: flowCategoriesReducer,
});
